import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Image } from '../../components/_all';
import './faq.scss';

const FAQSection = ({ payload }) => {
  const { faq } = payload;
  const { t } = useTranslation();

  if (!faq) return null;

  return (
    <section className="faq">
      <div className="faq__container">
        <h2>{t(faq.title)}</h2>
        {faq.items?.map((item, index) => (
          <details key={index} className="faq__container__itemCard">
            <summary className="faq__container__itemCard--item">
              <h3>{t(item.question)}</h3>
              <img src="/images/landing/chevron-down.svg" alt="Chevron" />
            </summary>
            <p>{t(item.answer)}</p>
          </details>
        ))}
        {faq.cta && (
          <div className="flex__class--rowCenter">
            <a className="button--secondary" href={faq.cta.href}>
              {t(faq.cta.label)}
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default FAQSection;